import { useState } from "react";
import styles from "./Footer.module.css";

export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);

  return (
    <>
      <footer className={styles.footer}>
        <div className={styles.container}>
          <button
            className={styles.link}
            onClick={() => setShowPrivacy(true)}
          >
            Privacy Policy
          </button>

          <a href="mailto:hello@totemfeed.com" className={styles.link}>
            Contact
          </a>

          <div className={styles.social}>
            <a
              href="https://twitter.com/totemfeed"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
              aria-label="Twitter"
            >
              <TwitterIcon />
            </a>
          </div>
        </div>
      </footer>

      {showPrivacy && (
        <PrivacyModal onClose={() => setShowPrivacy(false)} />
      )}
    </>
  );
}

function PrivacyModal({ onClose }: { onClose: () => void }) {
  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button className={styles.modalClose} onClick={onClose}>
          ×
        </button>
        <h2 className={styles.modalTitle}>Privacy Policy</h2>
        <div className={styles.modalContent}>
          <p>
            <strong>We don't collect personal data.</strong> Totemfeed is designed
            for anonymity.
          </p>
          <p>
            <strong>What we store:</strong>
          </p>
          <ul>
            <li>Your answers (anonymous, no account required)</li>
            <li>Session tokens (to track likes and prevent abuse)</li>
            <li>For paid answers: encrypted wallet address for payouts only</li>
          </ul>
          <p>
            <strong>Payments:</strong> All payments are made via x402 protocol.
            We only store encrypted wallet addresses to send winnings. We never
            see your private keys.
          </p>
          <p>
            <strong>Cookies:</strong> We use minimal cookies for session
            management and remembering your free/paid preference.
          </p>
          <p>
            <strong>Analytics:</strong> We use Cloudflare Web Analytics, which
            doesn't track individuals or use cookies.
          </p>
          <p>
            <strong>No accounts. No tracking. No selling data.</strong>
          </p>
        </div>
      </div>
    </div>
  );
}

function TwitterIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

